export const routes = {
  HOME: '/',
  QUOTES_MAKE: '/quotes',
  QUOTES: '/quotes',
  CONTRACTS: '/contracts',
  MISSING_PARTS: '/missingparts',
  UNPAID_SUSPENDED: '/unpaid',
  ACCOUNTING: '/accounting',
  CLAIMS: '/claims',
  MESSAGES: '/messages',
  DOCUMENTS: '/documents',
  CONTACTS: '/contacts',
  TRACFIN: '/tracfin'
};

export const customerRoutes = {
  HOME: '/',
  CONTACTS: '/contacts',
  MESSAGES: '/messages',
  CONTRACTS_CUSTOMER: '/contracts',
  MISSING_PARTS: '/missingparts',
  UNPAID_SUSPENDED: '/unpaid',
  ACCOUNTING: '/accounting',
  CLAIMS: '/claims',
  DOCUMENTS: '/documents',
  COMPLAINTS: '/complaints',
  ACCOUNTANT: '/myaccountant'
};

export const customerSubRoutes = {};

export const routesSiderRight = {
  BROKER_PROFILE: '/profile',
  BROKER_FIRM: '/mybrokerfirm',
  BROKER_TEAM: '/mybrokerteam',
  BROKER_DASHBOARD: '/dashboard',
  BROKER_CLIENTS: '/mybrokerCustomer',
  BROKER_SETTINGS: '/settings',
  BROKER_COMMISSIONS: '/mybrokercommissions',
  BROKER_COMPLIANCE: '/brokercompliance',
  BROKER_CLAIMS: '/reclamations',
  BROKER_GROUP: '/mygroup'
};

export const subRoutes = {
  QUOTES: {
    QUOTES_SAVED: '/quotessaved',
    QUOTES_IN_EXEMPTION: '/quotesinexemption'
  },
  CONTRACTS: {
    PORTFOLIO_CLIENTS: '/portfolioclients',
    PORTFOLIO_CONTRACTS: '/portfoliocontracts',
    PORTFOLIO_AMENDMENTS: '/amendments',
    PORTFOLIO_AMENDMENTS_IN_EXEMPTION: '/amendmentsinexemption'
  },
  QUOTES_MAKE: {
    RCNGA: '/productsquote/rcnga',
    RCP: '/productsquote/rcp',
    RCG: '/productsquote/rcg',
    MRP: '/productsquote/mrp',
    MRB: '/productsquote/mrb',
    MRI: '/productsquote/mri',
    PNO: '/productsquote/pno',
    PNE: '/productsquote/pne',
    ASSO: '/productsquote/asso',
    PREVOYANCE: '/productsquote/prev',
    // DO: '/productsquote/do',
    QUOTES_MAKE: '/productsquote/all'
  }
};

export const outOfNavRoutes = {
  LOGIN: '/login',
  CONFIRMATION: '/email-confirmation',
  PROFILE: '/profile',
  SETTINGS: '/settings',
  ESALES: '/esales'
};

export const pathSearches = {
  QUOTES_IN_EXEMPTION:
    '?s=-created_at&f=status=IN_PROGRESS,PENDING_REFERENT,PENDING_COMPANY,ACCEPTED,REFUSED,AWAITING_INFORMATION__',
  QUOTES_SAVED: '?p=1&pS=10&s=-created_at',
  PORTFOLIO_AMENDMENTS:
    '?s=-created_at&f=status=IN_PROGRESS,ACCEPTED,AWAITING_INFORMATION__',
  PORTFOLIO_AMENDMENTS_IN_EXEMPTION:
    '?s=-created_at&f=status=IN_PROGRESS,ACCEPTED,AWAITING_INFORMATION__',
  PORTFOLIO_CONTRACTS:
    '?s=-created_at&f=status=ACTIVE,UNPAID_1,UNPAID_2,FORMAL_NOTICE,WARRANTY_SUSPENSION,TERMINATED,TERMINATED_NON_PAYMENT,WITHOUT_EFFECT,ACTIVE_AFTER_SUSPENSION,PENDING,OBSOLETE__',
  MISSING_PARTS: '?s=-effective_date',
  UNPAID_SUSPENDED: '?s=-effective_date',
  BROKER_CLAIMS: '?s=-created_at'
};
